export default (fieldName, fieldType) => {
  if (!fieldType.$dirty) return [];
  let errors = [];
  fieldType.$params.required &&
    !fieldType.required &&
    errors.push(`${fieldName} est obligatoire`);
  fieldType.$params.minLength &&
    !fieldType.minLength &&
    errors.push(
      `${fieldName} doit contenir au moins ${fieldType.$params.minLength.min} caractères`
    );
  fieldType.$params.maxLength &&
    !fieldType.maxLength &&
    errors.push(
      `${fieldName} doit contenir au plus ${fieldType.$params.maxLength.max} caractères`
    );
  fieldType.$params.email &&
    !fieldType.email &&
    errors.push(`${fieldName} doit respecter la forme d'un Email`);
  fieldType.$params.numeric &&
    !fieldType.numeric &&
    errors.push(`${fieldName} doit contenir que des chiffres`);
  fieldType.$params.minValue &&
    !fieldType.minValue &&
    errors.push(
      `${fieldName} doit avoir une valeur minimale de ${fieldType.$params.minValue.min}`
    );
  fieldType.$params.sameAsPassword &&
    !fieldType.sameAsPassword &&
    errors.push(`${fieldName} n'est pas identique.`);
  return errors;
};
